import { render, staticRenderFns } from "./RegisterEquipmentCardWithTabs.vue?vue&type=template&id=22339468&scoped=true&"
import script from "./RegisterEquipmentCardWithTabs.vue?vue&type=script&lang=js&"
export * from "./RegisterEquipmentCardWithTabs.vue?vue&type=script&lang=js&"
import style0 from "./RegisterEquipmentCardWithTabs.vue?vue&type=style&index=0&id=22339468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22339468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22339468')) {
      api.createRecord('22339468', component.options)
    } else {
      api.reload('22339468', component.options)
    }
    module.hot.accept("./RegisterEquipmentCardWithTabs.vue?vue&type=template&id=22339468&scoped=true&", function () {
      api.rerender('22339468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/RegisterEquipmentCardWithTabs.vue"
export default component.exports